import config from '@/config.json';
const {
  FILES,
  PLAYERS,
  PROJECTS,
  SETTINGS,
  TEAMS,
  VENUES,
} = config.route;

export default {
  console_menu: [PROJECTS, FILES, TEAMS, PLAYERS, VENUES, SETTINGS],
  rpcServerRunning: false,
};
